module.exports = __webpack_public_path__ + "static/img/3_1_4_1.22ae2548.jpg";